import {
    apiRequest,
    riwayatPendidikanList,
    riwayatPendidikanActive,
    riwayatPendidikanInactive
} from "../../../../../services/adapters/kepegawaian/riwayatPendidikanService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", riwayatPendidikanList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", riwayatPendidikanInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", riwayatPendidikanActive, {
            body: query
        }, true)
    }
}

export default DataTableRepository